import { Component, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'importer-sub-header',
  templateUrl: './sub-header.component.html',
  styleUrls: ['./sub-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class SubHeaderComponent {
  private router = inject(Router);

  readonly title = input<string>('');

  openUploadPage() {
    this.router.navigate(['']);
  }

  openRepublishPage() {
    this.router.navigate(['republish']);
  }

  openSettingsPage() {
    this.router.navigate(['settings']);
  }

  openOrgManagementPage() {
    this.router.navigate(['organisation-management']);
  }
}
